import { FiltersOptions } from '../../common/filters.type';
import { useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

export type FetchFiltersResponseType = FiltersOptions;

export const useGetCandidatesFilters = () =>
  useGetFetch<FetchFiltersResponseType>({ url: pathToUrl(ApiRoutesEnum.candidatesFilters) });
